import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import { motion } from "framer-motion";
import Footer from "../components/Footer";
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';

// Componente de card isolado
const NicheCard = ({ title, description, link }) => {
    const [hovered, setHovered] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <motion.div
            style={{
                width: "200px",
                height: "200px",
                backgroundColor: link ? "#0b243d" : "#ffc845",
                borderRadius: "10px",
                cursor: "pointer",
                position: "relative",
                overflow: "hidden",
                transform: hovered ? "scale(1.05)" : "scale(1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                boxShadow: hovered ? "0 4px 15px rgba(0, 0, 0, 0.3)" : "none",
            }}
            onClick={() => link ? window.open(link, "_blank") : null}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
        >
            <p
                style={{
                    color: link ? "white" : "#0b243d",
                    textAlign: "center",
                    marginTop: "70px",
                    fontWeight: "bold",
                    padding: "0 10px"
                }}
            >
                {title}
            </p>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "50%" }}>
                <AddIcon sx={{ fontSize: "35px", color: "#0b243d" }} />
            </div>
            {hovered && (
                <div
                    style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        padding: "10px",
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        color: "white",
                        textAlign: "center",
                        fontSize: "14px",
                    }}
                >
                    {description}
                </div>
            )}
        </motion.div>
    );
};

const Niches = () => {
    const listNiches = [
        {
            title: "Médicos",
            description: "Contabilidade especializada para médicos, com foco em economia tributária e segurança fiscal.",
        },
        {
            title: "Dentistas",
            description: "Soluções contábeis específicas para clínicas e consultórios odontológicos.",
        },
        {
            title: "Psicólogos",
            description: "Organização fiscal e contábil sob medida para psicólogos autônomos ou clínicas.",
        },
        {
            title: "Fisioterapeutas",
            description: "Gestão contábil eficiente para quem atua com reabilitação e terapias físicas.",
        },
        {
            title: "Nutricionistas",
            description: "Serviços contábeis adaptados à rotina e legislação da nutrição.",
        },
        {
            title: "Fonoaudiólogos",
            description: "Cuidamos da parte fiscal para que você cuide da comunicação das pessoas.",
        },
        {
            title: "Biomédicos",
            description: "Atendimento contábil específico para quem atua em análises clínicas e laboratoriais.",
        },
        {
            title: "Personal Trainers",
            description: "Contabilidade para profissionais da educação física que atuam com treinamento personalizado, com foco na legalização e gestão eficiente dos ganhos.",
        },
        {
            title: "Não encontrou sua categoria?",
            description: "Clique e fale conosco para saber como podemos ajudar sua profissão.",
            link: gerarLinkWhatsApp("Olá! Não encontrei minha categoria na lista. Poderiam verificar se atendem minha profissão e me passar mais detalhes?"),
        },
    ];

    return (
        <>
            <Header active="nichos" />

            {/* Seção de introdução */}
            <div style={{
                marginTop: "60px",
                width: "100%",
                padding: "20px",
                backgroundColor: "#0b243d",
                color: "white"
            }}>
                <div
                    style={{
                        width: "90%",
                        maxWidth: "1200px",
                        margin: "0 auto",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "40px",
                        padding: "40px 20px",
                    }}
                >
                    {/* Imagem */}
                    <motion.div
                        style={{
                            flex: "1 1 350px",
                            display: "flex",
                            justifyContent: "center",
                        }}
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <img
                            src="/assets/nichos.jpeg"
                            alt="Descrição"
                            style={{
                                width: "100%",
                                margin: "0 auto",
                                height: "auto",
                                borderRadius: "20px", // cantos arredondados suaves
                                objectFit: "cover",   // mantém proporção e evita distorção
                                boxShadow: "0 0px 14px #ffc845", // sombra leve para destacar
                            }}
                        />
                    </motion.div>

                    {/* Texto */}
                    <motion.div
                        style={{
                            flex: "1 1 350px",
                            textAlign: "left",
                        }}
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        viewport={{ once: true }}
                    >
                        <h1
                            style={{
                                fontSize: "2.5rem",
                                fontWeight: "bold",
                                marginBottom: "16px",
                                color: "white",
                            }}
                        >
                            Nichos
                        </h1>
                        {/* <p
                            style={{
                                fontSize: "1.1rem",
                                lineHeight: "1.8",
                                color: "#555",
                                maxWidth: "500px",
                            }}
                        >
                            Entendemos que cada profissão tem suas particularidades. Por isso,
                            oferecemos um atendimento contábil personalizado para médicos,
                            dentistas, psicólogos, fisioterapeutas, nutricionistas, fonoaudiólogos,
                            biomédicos e demais profissionais da área da saúde. Nossos serviços
                            são adaptados à rotina e às exigências de cada especialidade,
                            garantindo suporte completo com foco em economia tributária,
                            organização financeira e segurança fiscal.
                        </p> */}
                    </motion.div>
                </div>

            </div>

            {/* Cards de nichos */}
            <div style={{ width: "100%", backgroundColor: "#f2f2f2", padding: "40px 0" }}>
                <div
                    style={{
                        width: "80%",
                        maxWidth: "1200px",
                        margin: "0 auto",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "30px",
                    }}
                >
                    {listNiches.map((niche, index) => (
                        <NicheCard key={index} title={niche.title} description={niche.description} link={niche.link ? niche.link : ""} />
                    ))}
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Niches;
